import React, { lazy, Suspense, useEffect, useState } from "react";
import { Box, Button, Tab, Tabs, Typography } from "@mui/material";
import { KeyboardBackspaceRounded } from "@mui/icons-material";
import { useNavigate, useOutletContext } from "react-router-dom";
import { myntra_reco_drawer } from "data/myntraRecoData";
// import MyntraSummary from "./myntraSummary";
// import UploadMyntraFiles from "./uploadMyntraFiles";
import MyntraRecoProvider from "context/MyntraReco";
// import MyntraDashboard from "./myntraDashboard";
// import RecoDocuments from "./recoDocuments";
// import MyntraOmniDashboard from "./MyntraOmni/myntraOmniDashboard";
// import MyntraOmniFileUpload from "./MyntraOmni/uploadMynbtraOmniFiles";
// import MyntraOmniSummary from "./MyntraOmni/myntraOmniSummary";
// import OmniRecoDocuments from "./MyntraOmni/myntraOmniDocuments";

const MyntraDashboard = lazy(() => import("./myntraDashboard"));
const UploadMyntraFiles = lazy(() => import("./uploadMyntraFiles"));
const MyntraSummary = lazy(() => import("./myntraSummary"));
const RecoDocuments = lazy(() => import("./recoDocuments"));
const MyntraFileCheck = lazy(() => import("./myntraFileCheck"));
const MyntraOmniFileCheck = lazy(() =>
  import("./MyntraOmni/myntraOmniFileCheck")
);

const MyntraOmniDashboard = lazy(() =>
  import("./MyntraOmni/myntraOmniDashboard")
);
const MyntraOmniFileUpload = lazy(() =>
  import("./MyntraOmni/uploadMynbtraOmniFiles")
);
const MyntraOmniSummary = lazy(() =>
  import("./MyntraOmni/myntraOmniSummary")
);
const OmniRecoDocuments = lazy(() =>
  import("./MyntraOmni/myntraOmniDocuments")
);

const Loader = () => (
  <Box textAlign="center" mt={4}>
    <Typography>Loading...</Typography>
  </Box>
);

export default function Myntra_reco() {
	const [tab, setTab] = useOutletContext();
	const [horizontalTab, setHorizontalTab] = useState(0);
	// Keep visited tabs mounted (hidden) so revisiting them doesn't refetch data
	const [visitedTabs, setVisitedTabs] = useState(() => (tab ? [tab] : []));
	useEffect(() => {
		if (tab && !visitedTabs.includes(tab)) {
			setVisitedTabs((prev) => [...prev, tab]);
		}
	}, [tab, visitedTabs]);
	const navigate = useNavigate();
	const [visitedHorizontalTabs, setVisitedHorizontalTabs] = useState([0]);
	const handleTabChange = (event, newValue) => {
		setHorizontalTab(newValue);
		setVisitedHorizontalTabs((prev) => (prev.includes(newValue) ? prev : [...prev, newValue]));
	};
	function a11yProps(index) {
		return {
			id: `simple-tab-${index}`,
			"aria-controls": `simple-tabpanel-${index}`,
		};
	}

	
	const tabStyle = { textTransform: "capitalize", fontSize: "16px", width: "170px" };
	const tabComponents = [
		{
			...myntra_reco_drawer.dashboard,
			component: <MyntraDashboard />,
		},
		{
			...myntra_reco_drawer.upload_files,
			component: <Box>
				<Tabs value={horizontalTab} onChange={handleTabChange} sx={{ borderBottom: 1, borderColor: "divider" }}>
				<Tab sx={tabStyle} label="Myntra PPMP" {...a11yProps(0)} />
				<Tab sx={tabStyle} label="Myntra OMNI" {...a11yProps(1)} />
			</Tabs>
			<Box display={horizontalTab === 0 ? "block" : "none"}>
				<Suspense fallback={<Loader />}>
					<UploadMyntraFiles />
				</Suspense>
			</Box>
			{visitedHorizontalTabs.includes(1) && (
				<Box display={horizontalTab === 1 ? "block" : "none"}>
					<Suspense fallback={<Loader />}>
						<MyntraOmniFileUpload />
					</Suspense>
				</Box>
			)}
			</Box>,
		},
		{
			...myntra_reco_drawer.summary,
			component: <MyntraSummary />,
		},
		{
			...myntra_reco_drawer.documents,
			component: <Box>
				<Tabs value={horizontalTab} onChange={handleTabChange} sx={{ borderBottom: 1, borderColor: "divider" }}>
				<Tab sx={tabStyle} label="Myntra COD" {...a11yProps(0)} />
				<Tab sx={tabStyle} label="Myntra OMNI" {...a11yProps(1)} />
			</Tabs>
			<Box display={horizontalTab === 0 ? "block" : "none"}>
				<RecoDocuments />
			</Box>
			{visitedHorizontalTabs.includes(1) && (
				<Box display={horizontalTab === 1 ? "block" : "none"}>
					<OmniRecoDocuments />
				</Box>
			)}
			</Box>
		},
		{
			...myntra_reco_drawer.file_check,
			component: <Box>
				<Tabs value={horizontalTab} onChange={handleTabChange} sx={{ borderBottom: 1, borderColor: "divider" }}>
				<Tab sx={tabStyle} label="Myntra PPMP" {...a11yProps(0)} />
				<Tab sx={tabStyle} label="Myntra OMNI" {...a11yProps(1)} />
			</Tabs>
			<Box display={horizontalTab === 0 ? "block" : "none"}>
				<Suspense fallback={<Loader />}>
					<MyntraFileCheck />
				</Suspense>
			</Box>
			{visitedHorizontalTabs.includes(1) && (
				<Box display={horizontalTab === 1 ? "block" : "none"}>
					<Suspense fallback={<Loader />}>
						<MyntraOmniFileCheck />
					</Suspense>
				</Box>
			)}
			</Box>,
		},
	];
	
	return (
		<div>
			<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
				<div>
					<Typography variant="h5" margin={"20px"} fontSize={28} textTransform="uppercase">
						MArketplace Reco
					</Typography>
				</div>
				<Button startIcon={<KeyboardBackspaceRounded />} variant="outlined" onClick={() => navigate("/explore")} sx={{ m: 2 }}>
					Back
				</Button>
			</div>
			{/* <Tabs value={horizontalTab} onChange={handleTabChange} sx={{ borderBottom: 1, borderColor: "divider" }}>
				<Tab sx={tabStyle} label="Myntra COD" {...a11yProps(0)} />
				<Tab sx={tabStyle} label="Myntra OMNI" {...a11yProps(1)} />
			</Tabs> */}
			{
				<MyntraRecoProvider>
					<div>
						{tabComponents &&
							tabComponents.map(
								(row) =>
									visitedTabs.includes(row.key) && (
										<Box
											width="95%"
											margin="auto"
											key={row.key}
											display={row.key === tab ? "block" : "none"}>
											<Suspense fallback={<Loader />}>{row.component}</Suspense>
										</Box>
									)
							)}
					</div>
				</MyntraRecoProvider>
			}
		</div>
	);
}
